export const messages = {
  en: {
    addInspectionPlan: {
      title: 'Add Plan',
      planName: 'Plan Name',
      inspectionRoute: 'Inspection Route',
      inspectionPeriod: 'Inspection Period',
      taskAdvance: 'Task Advance',
      minutesGenerate: 'minutes generate',
      month: 'Month',
      day: 'Day',
      week: 'Week',
      startDate: 'Start Date',
      endDate: 'End Date',
      startTime: 'Start Time',
      endTime: 'End Time',
      signMethod: 'Sign Method',
      allowRecheck: 'Allow Recheck',
      selectStaff: 'Select Staff',
      save: 'Save',
      back: 'Back',
      required: 'Required',
      monthlyDaily: 'Month/Day',
      weekly: 'Weekly',
      notAllowed: 'Not Allowed',
      allowed: 'Allowed',
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      page: {
        title: 'Add Inspection Plan',
        subtitle: 'Create an inspection plan and assign the staff who will execute it',
        loadFailed: 'Failed to load inspection plan options, please retry'
      },
      fetchDataError: "Failed to fetch plan data",
      startDateMustBeforeEndDate: "Start date must be before end date",
      saveError: "Failed to save plan",
    }
  },
  zh: {
    addInspectionPlan: {
      title: '添加计划',
      planName: '计划名称',
      inspectionRoute: '巡检路线',
      inspectionPeriod: '巡检周期',
      taskAdvance: '任务提前',
      minutesGenerate: '分钟生成',
      month: '月',
      day: '日',
      week: '周',
      startDate: '开始日期',
      endDate: '结束日期',
      startTime: '开始时间',
      endTime: '结束时间',
      signMethod: '签到方式',
      allowRecheck: '允许补检',
      selectStaff: '选择员工',
      save: '保存',
      back: '返回',
      required: '必填',
      monthlyDaily: '月/天',
      weekly: '按周',
      notAllowed: '不允许补检',
      allowed: '允许补检',
      monday: '星期一',
      tuesday: '星期二',
      wednesday: '星期三',
      thursday: '星期四',
      friday: '星期五',
      saturday: '星期六',
      sunday: '星期日',
      page: {
        title: '添加巡检计划',
        subtitle: '新建巡检计划并指定执行该计划的巡检人员',
        loadFailed: '巡检计划选项加载失败，请重试'
      },
      fetchDataError: "获取计划数据失败",
      startDateMustBeforeEndDate: "开始日期必须早于结束日期",
      saveError: "保存计划失败",
    }
  }
}